import { Row, Col, Input } from 'antd'
import moment from 'moment'
import { ButtonComponent as Button } from '../../components'
import { useState, useEffect } from 'react'
import { maskCurrency, getContractTypeName, getDisplayContractName } from '../../utils/functions';

// Adaptador para transformar o formato de dados da API
const adaptWithdrawlData = (withdrawl) => {
    if (!withdrawl) return null;
    
    // Cria uma cópia do objeto para não modificar o original
    const adapted = { ...withdrawl };
    
    // Verifica se o contrato existe em formato básico (só ID)
    if (!adapted.Contrato && (adapted.contrato || adapted.idContrato)) {
        // Cria objeto Contrato padronizado
        adapted.Contrato = {
            id: adapted.contrato?.id || adapted.idContrato,
            tipoContrato: (adapted.contrato?.tipoContrato != null ? adapted.contrato.tipoContrato : (adapted.tipo === 'spirit' ? 6 : adapted.tipo === 'asa' ? 1 : undefined)),
            tipoContratoNome: adapted.contrato?.tipoContratoNome,
            // Adicionar campos bancários do paymentInfo se disponíveis
            codigoBanco: adapted.paymentInfo?.codigoBanco,
            nomeBanco: adapted.paymentInfo?.nomeBanco,
            numeroAgencia: adapted.paymentInfo?.numeroAgencia,
            numeroConta: adapted.paymentInfo?.numeroConta,
            tipoConta: adapted.paymentInfo?.tipoConta
        };
    }
    
    // Garantir que tipoContrato e tipoContratoNome estejam preenchidos a partir de `contrato` quando disponíveis
    if (adapted.Contrato) {
        if (adapted.Contrato.tipoContrato == null && adapted.contrato?.tipoContrato != null) {
            adapted.Contrato.tipoContrato = adapted.contrato.tipoContrato;
        }
        if (!adapted.Contrato.tipoContratoNome && adapted.contrato?.tipoContratoNome) {
            adapted.Contrato.tipoContratoNome = adapted.contrato.tipoContratoNome;
        }
    }
    
    // Se o Contrato não tem Cliente mas temos informações do usuário
    if (adapted.Contrato && !adapted.Contrato.Cliente && adapted.usuario) {
        adapted.Contrato.Cliente = {
            id: adapted.usuario.id,
            nome: adapted.usuario.nome,
            cpf: adapted.usuario.cpf,
            email: adapted.usuario.email
        };
    }
    
    return adapted;
};

const DenyWithdrawl = (props) => {
    const { withdrawl: originalWithdrawl, handleModal, deny } = props
    const [reason, setReason] = useState('')
    
    // Adaptar os dados do resgate
    const [withdrawl, setWithdrawl] = useState(null);
    
    useEffect(() => {
        if (originalWithdrawl) {
            setWithdrawl(adaptWithdrawlData(originalWithdrawl));
        }
    }, [originalWithdrawl]);
    
    // Verificar se existe um objeto de resgate
    if (!withdrawl) {
        return (
            <>
                <Row>
                    <Col md={20} className="d-flex align-center">
                        <h1 className="font-bold font-28 tx-white">Reprovação de Resgate</h1>                
                    </Col>
                    <Col md={4} className="d-flex align-center justify-end">
                        <label className="tx-white btn-close" onClick={handleModal}>Cancelar</label>
                    </Col>
                </Row>
                <Row className="deny-info-wrapper">
                    <Col md={24}>
                        <div className="d-flex align-center justify-center flex-column p-20">
                            <h3 className="tx-pink font-bold">Carregando dados...</h3>
                            <p className="tx-white mt-10">Aguarde enquanto processamos os dados do resgate.</p>
                            <Button type="danger" onClick={handleModal} className="mt-15">Fechar</Button>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
    
    // Se não tem Contrato, tenta usar campos alternativos da API
    const userInfo = withdrawl.usuario || {};
    const contractInfo = withdrawl.contrato || {};
    const contractId = withdrawl.Contrato?.id || contractInfo?.id || withdrawl.idContrato || 'N/A';
    const contratoSafe = withdrawl.Contrato || {};
    const nomeTipoContrato = contratoSafe.tipoContratoNome || contractInfo?.tipoContratoNome;
    const tipoLabel = getDisplayContractName(nomeTipoContrato, contratoSafe.tipoContrato);
    
    // Verificar se o contrato contém informações do cliente
    const hasValidContractAndClient = contratoSafe.Cliente != null;
    
    // Se o contrato não tem cliente, use informações do campo usuario se disponível
    const clienteNome = hasValidContractAndClient ? contratoSafe.Cliente.nome : (userInfo.nome || 'Nome indisponível');

    const handleChange = (e) => {
        setReason(e.target.value)
    }

    const denyWithdrawl = () => {
        if (!withdrawl || !withdrawl.id) {
            console.error('Tentativa de negar resgate sem ID válido');
            return;
        }
        handleModal()
        deny(reason, withdrawl.id, false)
    }

    return (
        <>
        <Row>
            <Col md={20} className="d-flex align-center">
                <h1 className="font-bold font-28 tx-white">Reprovação de Resgate</h1>                
            </Col>
            <Col md={4} className="d-flex align-center justify-end">
                <label className="tx-white btn-close" onClick={handleModal}>Cancelar</label>
            </Col>
        </Row>
        <Row className="deny-info-wrapper">
            <Col md={12} className="border">
                <Row>
                    <Col md={20}>
                        <h3 className="tx-pink font-bold">{clienteNome}</h3>
                    </Col>
                    <Col md={4}>
                        <label className="tx-pink font-bold">{tipoLabel}</label><br />
                        <label className="tx-gray font-16">#{contractId}</label>
                    </Col>
                    <Col md={24}>
                        <hr />
                    </Col>
                    <Col md={12} className="mt-10">
                        <label className="tx-pink font-bold">Solicitação</label><br />
                        <label className="tx-gray">{withdrawl.createdAt ? moment(withdrawl.createdAt).format("DD/MM/YYYY") : 'N/A'}</label>
                    </Col>
                    <Col md={24} className="mt-10">
                        <hr />
                    </Col>
                    <Col md={24} className="mt-10">
                        <label className="tx-pink font-bold">Valor</label><br />
                        <label className="tx-gray font-bold font-22">R$ {maskCurrency(withdrawl.valor || 0)}</label>
                    </Col>
                </Row>
            </Col>
            <Col md={12} className="pl-20">
                <label className="tx-pink font-bold font-16">Motivo da reprovação</label>
                <Input.TextArea placeholder="Digite aqui o motivo da reprovação" className="mt-15 bg-white" onChange={handleChange} value={reason} />
                <Row className="mt-30">
                    <Col md={12}>
                        <label className="tx-gray btn-close" onClick={handleModal}>Cancelar</label>
                    </Col>
                    <Col md={12}>
                        <Button type="danger" onClick={denyWithdrawl}>Reprovar</Button>
                    </Col>
                </Row>
            </Col>
        </Row>
        </>
    )
}

export default DenyWithdrawl